module.exports = __webpack_public_path__ + "img/placard_m_02.5fbce888.png";